import Joi from '@hapi/joi'

export const DairyCollectionDetailedReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Factory").messages({
        "any.invalid": `Please select valid Factory`,
        "any.required": `Factory required`
    }),
    date: Joi.string().invalid("").label("Date").required().messages({
        "string.empty": `Date Required`,
        "string.pattern.base": `Please enter valid Date`,
    }),
    collectionPointID: Joi.number().allow("").label("CollectionPoint").messages({
        
    }),
}